import axios from 'axios';
import urljoin from 'url-join';

/* eslint-disable no-param-reassign */
export default {
  namespaced: true,
  state: {
    apiBaseUrl: null,
    settings: null,
    language: localStorage.getItem('appLanguage'),
  },
  getters: {
    language() {
      if (localStorage.getItem('appLanguage') === null) return 'fr';
      return localStorage.getItem('appLanguage');
    },
    adfsSettings: (state) => state.settings?.adfs || {},
  },
  actions: {
    async loadSettings({ commit }) {
      const url = urljoin(window.location.origin, '/appsettings.json');
      try {
        const response = await axios.get(url, {
          responseType: 'json',
        });
        commit('updateConfiguration', response.data);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(`ERROR api config: ${error}`);// TODO notification system
      }
    },
    setLanguage({ commit }, lang) {
      commit('setAppLanguage', lang);
    },
  },
  mutations: {
    updateConfiguration(state, data) {
      state.apiBaseUrl = data.apiBaseUrl;
      state.settings = Object.freeze({ ...data });
    },
    setAppLanguage(state, language) {
      state.appLanguage = language;
      localStorage.setItem('appLanguage', language);
    },
  },
};
